let checkIfFieldExist = setInterval(function() {
  let $field = $('.weglot-container');
  let $container = $('.header .header__languages');

  if ($field.length) {
    clearInterval(checkIfFieldExist);
    $container.append($field)
  }

}, 100);
